// extracted by mini-css-extract-plugin
export default {"star":"FavoriteStar_star__QRpW9"};